export const COMMISSION_POPUP_MODE = {
    VIEW: 1,
    ADD: 2
}

export const COMMISSION_ADD_FIELDS = {
    COMMISSION: "id",
    COMMISSION_TYPE: "type",
    START_AND_END_DATE: "startAndEndDate",
    START_DATE: "startDate",
    END_DATE: "endDate",
}

export const COMMISSION_EDIT_FIELDS = {
    START_AND_END_DATE: "startAndEndDate"
}

export const commissionPlanStatuses = {
    Deleted: -1,
    Active: 1,
    Scheduled: 2,
    Inactive: 3,
    Expired: 4,
}

export const COMMISSION_PLAN_STATE_COLORS = {
    [commissionPlanStatuses.Active]: "green",
    [commissionPlanStatuses.Scheduled]: "orange",
    [commissionPlanStatuses.Inactive]: "grey",
    [commissionPlanStatuses.Expired]: "red",
}

export const COMMISSION_PLAN_STATE_TRANSLATIONS = {
    [commissionPlanStatuses.Active]: "backoffice.common.active",
    [commissionPlanStatuses.Scheduled]: "backoffice.common.scheduled",
    [commissionPlanStatuses.Inactive]: "backoffice.common.inactive",
    [commissionPlanStatuses.Expired]: "backoffice.common.expired",
}